import React from "react";
import { Link } from "react-router-dom";
import Header from "../../Common/Layout/Header"; 
import { useAuth } from "../../Common/Configurations/AuthContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt, faPalette, faCode, faDesktop } from '@fortawesome/free-solid-svg-icons';
import "./WebsiteShowcase.css";
import DMCPackageTab from "../../Components/AllTabs/DMCPackageTab";

const HolidayWebsiteShowcase = () => {
    const { user } = useAuth();

    // Data for your 4 websites - Update the 'img' paths after saving your screenshots
    const demos = [
        {
            id: 1,
            title: "Premium Corporate",
            desc: "Clean, white-themed DMC interface with blue/orange accents. Perfect for B2B booking engines.",
            path: "/website1",
            badge: "Professional",
            color: "primary",
            img: "/assets/images/Website1.png" // Save your screenshot here
        },
        {
            id: 2,
            title: "Cinematic Dark Luxury",
            desc: "Immersive dark mode with Ken Burns effect sliders. Designed for high-end luxury travel.",
            path: "/website2",
            badge: "Cinematic",
            color: "dark",
            img: "/assets/images/Website2.png" // Save your screenshot here
        },
        {
            id: 3,
            title: "Modern Nature & Editorial",
            desc: "Split-hero layout with forest greens and cream tones. Features masonry grids and story avatars.",
            path: "/website3",
            badge: "Editorial",
            color: "success",
            img: "/assets/images/Website3.png" // Save your screenshot here
        },
        {
            id: 4,
            title: "Classic & Elegant",
            desc: "Timeless brochure style with serif typography, borders, and a sophisticated gold/charcoal palette.",
            path: "/website4",
            badge: "Classic",
            color: "warning",
            img: "/assets/images/Website4.png" // Save your screenshot here
        }
    ];

    return (
        <div id="layout-wrapper" style={{ background: '#f3f4f6', minHeight: '100vh' }}>
            <Header User={user} activeSection="showcase" />
            
            <div className="main-content" style={{  padding: '20px' }}>
                <div className="page-content">
                    <div className="container-fluid">
                         <div className="p-2">
                {/* <DMCPackageTab pageName="YOUR_WEBSITE" /> */}
              </div>
                        {/* Header Section */}
                        <div className="row mb-1 text-center">
                            <div className="col-lg-8 mx-auto">
                                <h2 className="holiday-webisteshowcase-title">UI Design Gallery</h2>
                                <p className="text-muted">
                                    Select a design template below to preview the full website experience. 
                                    Each template is crafted for a specific travel audience.
                                </p>
                            </div>
                        </div>

                        {/* Cards Grid */}
                        <div className="row justify-content-center">
                            {demos.map((demo) => (
                                <div key={demo.id} className="col-xl-3 col-md-6 mb-4">
                                    <div className="card h-100 border-0 shadow-lg holiday-webisteshowcase-card">
                                        
                                        {/* Image Section */}
                                        <div className="holiday-webisteshowcase-img-wrapper">
                                            <img 
                                                src={demo.img} 
                                                alt={demo.title} 
                                                className="holiday-webisteshowcase-img" 
                                                onError={(e) => { e.target.src = "https://via.placeholder.com/800x600?text=Screenshot+Coming+Soon"; }}
                                            />
                                            <div className="holiday-webisteshowcase-overlay">
                                                <Link 
                                                    to={demo.path} 
                                                    target="_blank" 
                                                    rel="noopener noreferrer"
                                                    className="btn btn-light rounded-pill px-4 fw-bold"
                                                >
                                                    <FontAwesomeIcon icon={faExternalLinkAlt} className="me-2" />
                                                    Live Preview
                                                </Link>
                                            </div>
                                            <span className={`badge bg-${demo.color} holiday-webisteshowcase-badge`}>
                                                {demo.badge}
                                            </span>
                                        </div>

                                        {/* Content Section */}
                                        <div className="card-body p-4 text-center d-flex flex-column">
                                            <h5 className="card-title fw-bold mb-2">{demo.title}</h5>
                                            <p className="text-muted small flex-grow-1">{demo.desc}</p>
                                            
                                        

                                            <Link 
                                                to={demo.path} 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                className={`btn btn-soft-${demo.color} w-100 mt-3 fw-bold`}
                                            >
                                                Launch Website
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default HolidayWebsiteShowcase;